import React from 'react';
import { Box, TextButton } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import { useTemplateContext } from '@components/Contexts/TemplateContext';
import { useMoreByPartnerTemplates } from '../useRecommendedTemplates';
import RecommendedSection from '../RecommendedSection';

function getPartnerTemplatesUrl(slug: string, language = 'en') {
  const subdomain = language === 'en' ? 'www' : language;
  return `https://${subdomain}.wix.com/studio/community/partners/${slug}#templates`;
}

const SHOW_MORE_FOR_MORE_THEN_SITES_NUMBER = 4;

interface Props {
  isMobileView?: boolean;
}

const MoreByPartner: React.FC<Props> = ({ isMobileView = false }) => {
  const { t, i18n } = useTranslation();
  const { template } = useTemplateContext();
  const partnerName = template.partnerProfileDetails?.businessName;
  const slug = template.partnerProfileDetails?.slug;
  const { data, isLoading } = useMoreByPartnerTemplates(template);
  const partnerTemplates = data?.templates;
  const totalCount = data?.totalCount ?? 0;

  if (isLoading || !partnerTemplates || partnerTemplates.length === 0) {
    return null;
  }

  return (
    <RecommendedSection
      title={
        <>
          {t('marketplace.template-page.more-by-partner.prefix', {
            partnerName,
          })}
        </>
      }
      action={
        slug && totalCount > SHOW_MORE_FOR_MORE_THEN_SITES_NUMBER ? (
          <Box margin={isMobileView ? '0 24px 0 30px' : '0'}>
            <TextButton
              target="_blank"
              skin="dark"
              underline="always"
              as="a"
              href={getPartnerTemplatesUrl(slug, i18n.language)}
            >
              {t('marketplace.template-page.more-by-partner.see-all')}
            </TextButton>
          </Box>
        ) : undefined
      }
      templates={partnerTemplates}
      sectionType="more_by_partner"
      dataHook="more-by-partner"
      isMobileView={isMobileView}
    />
  );
};

export default MoreByPartner;
